/**
 * Μηνύματα κουζίνας (dine_in_settings.kitchen_messages_enabled): «ΠΑΣΟ ΚΥΡΙΩΣ», «ΟΛΑ ΜΑΖΙ» …
 * Κοινά για ταμείο και PDA. Ίδια όρια με το backend (backend/utils/kitchenMessages.js).
 *
 * Δεν είναι είδη: δεν έχουν τιμή, δεν μπαίνουν στο καλάθι, ούτε σε 8.6/απόδειξη.
 */

export const KITCHEN_MESSAGE_MAX_LENGTH = 40;
export const KITCHEN_MESSAGES_PER_SEND = 5;
export const KITCHEN_MESSAGE_LIST_MAX = 30;

/** Τα έτοιμα μηνύματα του καταστήματος· `null` όταν η λειτουργία είναι κλειστή. */
export function kitchenMessagePresets(
  settings: { kitchen_messages_enabled?: boolean; kitchen_messages?: unknown } | null | undefined
): string[] | null {
  if (settings?.kitchen_messages_enabled !== true) return null;
  const list = Array.isArray(settings.kitchen_messages) ? settings.kitchen_messages : [];
  return list.filter((m): m is string => typeof m === 'string' && m.trim() !== '');
}

export const cleanKitchenMessage = (text: string): string => text.replace(/\s+/g, ' ').trim();

// «Πάσο κυρίως» = «ΠΑΣΟ ΚΥΡΙΩΣ»: στο δελτίο τυπώνονται κεφαλαία χωρίς τόνους.
const sameKey = (text: string): string =>
  cleanKitchenMessage(text).normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase();

export const isKitchenMessageSelected = (selected: string[], message: string): boolean =>
  selected.some((m) => sameKey(m) === sameKey(message));

/** Πάτημα σε μήνυμα: μπαίνει ή βγαίνει από την επιλογή — έως 5, όπως δέχεται ο server. */
export function toggleKitchenMessage(selected: string[], message: string): string[] {
  const clean = cleanKitchenMessage(message);
  if (!clean) return selected;
  if (isKitchenMessageSelected(selected, clean)) return selected.filter((m) => sameKey(m) !== sameKey(clean));
  if (selected.length >= KITCHEN_MESSAGES_PER_SEND) return selected;
  return [...selected, clean.slice(0, KITCHEN_MESSAGE_MAX_LENGTH)];
}

/** Η επιλογή μαζί με ό,τι γράφτηκε στο πεδίο και δεν πατήθηκε «Προσθήκη». */
export function withDraftMessage(selected: string[], draft: string): string[] {
  const clean = cleanKitchenMessage(draft);
  if (!clean || isKitchenMessageSelected(selected, clean)) return selected;
  return toggleKitchenMessage(selected, clean);
}

/** Η λίστα των ρυθμίσεων με ένα ακόμη μήνυμα (στο τέλος)· ίδια λίστα αν είναι κενό, διπλό ή γεμάτη. */
export function addPresetMessage(list: string[], message: string): string[] {
  const clean = cleanKitchenMessage(message).slice(0, KITCHEN_MESSAGE_MAX_LENGTH);
  if (!clean || isKitchenMessageSelected(list, clean) || list.length >= KITCHEN_MESSAGE_LIST_MAX) return list;
  return [...list, clean];
}

/** Μετακίνηση στη λίστα των ρυθμίσεων (−1 πάνω, +1 κάτω). */
export function movePresetMessage(list: string[], index: number, delta: -1 | 1): string[] {
  const target = index + delta;
  if (index < 0 || index >= list.length || target < 0 || target >= list.length) return list;
  const next = [...list];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}
